module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAHxJREFUOE9jZKASYASZc6Qmx+/f//8zQWwmRsZ0m5Ypm5DFGRkZJbDZ9////xcw9WCDDlVnP4cr/v//hW3rVEkMcVwuh6qnskHlef6MLH9ngCz9/4c5w65z0kawi2DiOLzG8P//C5h6sIuoAahr0GisYcbJaKyh5sGRm9cADN/JE27+mV4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/commonR.png
// module id = 478
// module chunks = 0